import { useQuery } from "@tanstack/react-query"
import api from "../../http"
import { ConsultantDashboard } from "./responsesType/consultantResponseType";
import { FarmerDashboard } from "./responsesType/farmerResponseType";
import { CompanyDashboard } from "./responsesType/companyResponseType";
import { AdminDashboard } from "./responsesType/adminResponseType";
import { useForBindingId } from "../../../forBinding";

export type DashboardResponse =
    | ConsultantDashboard
    | FarmerDashboard
    | CompanyDashboard
    | AdminDashboard;

export const useGetDashboardInfos = () => {
    const forBinding = useForBindingId();

    return useQuery({
        queryKey: ['dashboard', forBinding],
        queryFn: async () => {
            const { data } = await api.get<DashboardResponse>('/dashboard/infos', {
                params: { forBinding }
            })
            return data
        }
    });
}
